import React from 'react';
import { useTranslation } from 'react-i18next';
import IcfInNotInMultiSelect from 'components/commons/IssueCrashFilter/IcfInNotInMultiSelect';

const CPU_ARCH_OPTIONS = [
  { label: 'arm64-v8a', value: 'arm64-v8a' },
  { label: 'armeabi-v7a', value: 'armeabi-v7a' },
  { label: 'x86_64', value: 'x86_64' },
  { label: 'x86', value: 'x86' },
];

const IcfCpuArchSelect = ({
  isReadOnly,
  fieldValue,
  onChangeFieldValue,
}) => {
  const { t } = useTranslation();

  return (
    <IcfInNotInMultiSelect
      isReadOnly={isReadOnly}
      fieldValue={fieldValue}
      onChangeFieldValue={onChangeFieldValue}
      options={CPU_ARCH_OPTIONS}
      placeholder={t('issueCrashFilter.anyPlaceholder')}
    />
  );
};

export default IcfCpuArchSelect;
